<template>
  <div id="app">
    <b-table
      striped
      hover
      responsive
      table-class="w-100"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :small="small"
      :dark="dark"
      :fixed="fixed"
      :foot-clone="footClone"
      :no-border-collapse="noCollapse"
      :items="items"
      :fields="visibleFields"
      :head-variant="headVariant"
      :table-variant="tableVariant"
      class="w-100"
      show-empty>
      <template #cell()="data">
        <div :style="getColumnStyles(data)">
          {{ data.value }}
        </div>
      </template>
      <template #empty="scope">
        <div style="text-align: center;">
          За выбранный период данные отсутствуют
        </div>
      </template>
    </b-table>
  </div>
</template>


<script>
  export default {
    name: "WSResultsTable",
    props: {
      fields: {
        type: Array,
        default: [],
      },
      items: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        loading: true,
        striped: false,
        bordered: false,
        borderless: false,
        outlined: false,
        small: false,
        hover: false,
        dark: false,
        fixed: false,
        footClone: false,
        headVariant: null,
        tableVariant: "",
        noCollapse: false,
      };
    },
    computed: {
      visibleFields() {
        return this.fields.filter(field => !field.hidden);
      }
    },
    methods: {
      getColumnStyles(data) {
        // Первая колонка (Период) - по левому краю, остальные - по центру
        const textAlign = (data.field.key === 'period' || data.field.key === 'Период') ? 'left' : 'center';
        return { textAlign };
      },
    },
  }
</script>